// extracted by mini-css-extract-plugin
module.exports = {"container":"tip4oQHlJ0zehTkm8LJdl","headerHolder":"_2lXdnlVGOwcTrOxX4lMXGB","info":"Hp-DlYnf9Ckk5RFH2XH3d","curtain":"_2Uc7H9mCL3zMCqVIdLU8kK"};